"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const euclid_1 = require("@reality/euclid");
const player = {
    resourceID: "player",
    url: "/player.png",
    spriteSize: 32,
    layers: {
        [euclid_1.Direction.DOWN]: {
            layerID: euclid_1.Direction.DOWN.toString(),
            resourceID: "player",
            sprite: { x: 0, y: 0 },
        },
        ["walk0" + euclid_1.Direction.DOWN]: {
            layerID: euclid_1.Direction.DOWN.toString(),
            resourceID: "player",
            sprite: { x: 1, y: 0 },
        },
        ["walk1" + euclid_1.Direction.DOWN]: {
            layerID: euclid_1.Direction.DOWN.toString(),
            resourceID: "player",
            sprite: { x: 2, y: 0 },
        },
        ["walk2" + euclid_1.Direction.DOWN]: {
            layerID: euclid_1.Direction.DOWN.toString(),
            resourceID: "player",
            sprite: { x: 3, y: 0 },
        },
        [euclid_1.Direction.LEFT]: {
            layerID: euclid_1.Direction.LEFT.toString(),
            resourceID: "player",
            sprite: { x: 0, y: 1 },
        },
        ["walk0" + euclid_1.Direction.LEFT]: {
            layerID: euclid_1.Direction.LEFT.toString(),
            resourceID: "player",
            sprite: { x: 1, y: 1 },
        },
        ["walk1" + euclid_1.Direction.LEFT]: {
            layerID: euclid_1.Direction.LEFT.toString(),
            resourceID: "player",
            sprite: { x: 2, y: 1 },
        },
        ["walk2" + euclid_1.Direction.LEFT]: {
            layerID: euclid_1.Direction.LEFT.toString(),
            resourceID: "player",
            sprite: { x: 3, y: 1 },
        },
        [euclid_1.Direction.RIGHT]: {
            layerID: euclid_1.Direction.RIGHT.toString(),
            resourceID: "player",
            sprite: { x: 0, y: 2 },
        },
        ["walk0" + euclid_1.Direction.RIGHT]: {
            layerID: euclid_1.Direction.RIGHT.toString(),
            resourceID: "player",
            sprite: { x: 1, y: 2 },
        },
        ["walk1" + euclid_1.Direction.RIGHT]: {
            layerID: euclid_1.Direction.RIGHT.toString(),
            resourceID: "player",
            sprite: { x: 2, y: 2 },
        },
        ["walk2" + euclid_1.Direction.RIGHT]: {
            layerID: euclid_1.Direction.RIGHT.toString(),
            resourceID: "player",
            sprite: { x: 3, y: 2 },
        },
        [euclid_1.Direction.UP]: {
            layerID: euclid_1.Direction.UP.toString(),
            resourceID: "player",
            sprite: { x: 0, y: 3 },
        },
        ["walk0" + euclid_1.Direction.UP]: {
            layerID: euclid_1.Direction.UP.toString(),
            resourceID: "player",
            sprite: { x: 1, y: 3 },
        },
        ["walk1" + euclid_1.Direction.UP]: {
            layerID: euclid_1.Direction.UP.toString(),
            resourceID: "player",
            sprite: { x: 2, y: 3 },
        },
        ["walk2" + euclid_1.Direction.UP]: {
            layerID: euclid_1.Direction.UP.toString(),
            resourceID: "player",
            sprite: { x: 3, y: 3 },
        },
    },
};
exports.default = player;
//# sourceMappingURL=player.js.map